import { render, staticRenderFns } from "./Damnnpx.vue?vue&type=template&id=39404cd4&"
import script from "./Damnnpx.vue?vue&type=script&lang=js&"
export * from "./Damnnpx.vue?vue&type=script&lang=js&"
import style0 from "./Damnnpx.vue?vue&type=style&index=0&id=39404cd4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports